<template>
  <b-row>
    <b-col cols="12">

      <PurchaseIndex :routeName="$route.name"
      />

    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import PurchaseIndex from './PurchaseIndex.vue'

export default {
  components: {
    BRow,
    BCol,
    PurchaseIndex
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
